module.exports = __webpack_public_path__ + "media/images/error2-da3e3794a4fac294c9dac96d810f0ef7.svg";